import API from "./restApi";
import { AxiosResponse } from "axios";

let config = require("../configuration/config");

export function apiGetMyToDo(): Promise<AxiosResponse> {
  return API.get(`${config.serverUrl}/api/mytodos`);
}

export function apiAddOrUpdateToDo(formData): Promise<AxiosResponse> {
  return API.post(
    `${config.serverUrl}/api/addorupdateTodo`,
    JSON.stringify(formData),
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json,charset=UTF-8",
      },
    }
  );
}

export function apiQuickUpdateToDo(formData): Promise<AxiosResponse> {
  return API.post(
    `${config.serverUrl}/api/quickUpdateTodo`,
    JSON.stringify(formData),
    {
      headers: {
        Accept: "application/json",
        "Content-Type": "application/json,charset=UTF-8",
      },
    }
  );
}

export function apiDeleteToDo(id): Promise<AxiosResponse> {
  return API.delete(`${config.serverUrl}/api/todos/${id}`);
}
